import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { GroupService } from './group.service';

@Injectable({
  providedIn: 'root'
})
export class GroupResolve implements Resolve<any> {

  constructor(private gs: GroupService) { }

  resolve(route: ActivatedRouteSnapshot){
    return this.gs.updateGroup(route.params.id)
  }
}
